import React from "react";
import {
  convertToThousands,
} from "../../helpers/NumberFormatter";

export default function DiffAndChange(props) {
  const { field, item, onlyPercentage = false, className = "", currency } = props,
    change = Number(item[field + "_change"]),
    diff = Number(item[field + "_diff"]),
    direction = change > 0 ? "up" : "down";

  let percentage = change;
  if (diff < 0 && change == 0) percentage = '-100';
  if (change > 100) 
    percentage = "> 100";
  else if (change < -100) 
    percentage = "> -100";
  else if (diff == 0) 
    percentage = "0"
    
  return (
    <span title={diff} className="vendor-value">
      {!onlyPercentage && convertToThousands(diff, 2, currency)}
      <span className={`${direction} ${className}`}>
        {percentage}%
      </span>
    </span>
  );
}
